import React from 'react'

const TermsOfService = () => {
    return (
        <div className="contact_us">
            <h3 className="title">Volt Terms of Service</h3>
            <iframe
                src={`${process.env.REACT_APP_API_URL}user/content/terms`}
                style={{ width: "100%", height: "500px" }}
            />
        </div>
    )
}

export default TermsOfService